import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faVideo,
  faArrowRight,
  faArrowUpRightFromSquare,
  faBook,
  faPlayCircle,
  faStickyNote,
  faTriangleExclamation,
  faCircleCheck,
  faXmark,
  faCalendarDay,
  faHourglassHalf,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import 'flag-icons/css/flag-icons.min.css';
import { useDemoProjects, demoForCourse } from '../components/demoProjects';
import './Classes.css';


/* ---------- Flag from the time zone ----------
   Used when the server sends no country code (e.g. demo classes).
   Add a line if a flag is missing. */
// "Zone=countrycode;..." — every zone in the IANA tz database (zone.tab) + old names
const TZ_TABLE =
  'Africa/Abidjan=ci;Africa/Accra=gh;Africa/Addis_Ababa=et;Africa/Algiers=dz;Africa/Asmara=er;Africa/Asmera=er;Africa/Bamako=ml;Africa/Bangui=cf;Africa/Banjul=gm;Africa/Bissau=gw;Africa/Blantyre=mw;Africa/Brazzaville=cg;Africa/Bujumbura=bi;Africa/Cairo=eg;Africa/Casablanca=ma;Africa/Ceuta=es;Africa/Conakry=gn;Africa/Dakar=sn;Africa/Dar_es_Salaam=tz;Africa/Djibouti=dj;Africa/Douala=cm;Africa/El_Aaiun=eh;Africa/Freetown=sl;Africa/Gaborone=bw;Africa/Harare=zw;Africa/Johannesburg=za;Africa/Juba=ss;Africa/Kampala=ug;Africa/Khartoum=sd;Africa/Kigali=rw;Africa/Kinshasa=cd;Africa/Lagos=ng;Africa/Libreville=ga;Africa/Lome=tg;Africa/Luanda=ao;Africa/Lubumbashi=cd;Africa/Lusaka=zm;Africa/Malabo=gq;Africa/Maputo=mz;Africa/Maseru=ls;Africa/Mbabane=sz;Africa/Mogadishu=so;Africa/Monrovia=lr;Africa/Nairobi=ke;Africa/Ndjamena=td;Africa/Niamey=ne;Africa/Nouakchott=mr;Africa/Ouagadougou=bf;Africa/Porto-Novo=bj;Africa/Sao_Tome=st;Africa/Tripoli=ly;Africa/Tunis=tn;Africa/Windhoek=na;America/Adak=us;America/Anchorage=us;America/Anguilla=ai;America/Antigua=ag;America/Araguaina=br;America/Argentina/Buenos_Aires=ar;America/Argentina/Catamarca=ar;America/Argentina/Cordoba=ar;America/Argentina/Jujuy=ar;America/Argentina/La_Rioja=ar;America/Argentina/Mendoza=ar;America/Argentina/Rio_Gallegos=ar;America/Argentina/Salta=ar;America/Argentina/San_Juan=ar;America/Argentina/San_Luis=ar;America/Argentina/Tucuman=ar;America/Argentina/Ushuaia=ar;America/Aruba=aw;America/Asuncion=py;America/Atikokan=ca;America/Bahia=br;America/Bahia_Banderas=mx;America/Barbados=bb;America/Belem=br;America/Belize=bz;America/Blanc-Sablon=ca;America/Boa_Vista=br;America/Bogota=co;America/Boise=us;America/Buenos_Aires=ar;America/Cambridge_Bay=ca;America/Campo_Grande=br;America/Cancun=mx;America/Caracas=ve;America/Cayenne=gf;America/Cayman=ky;America/Chicago=us;America/Chihuahua=mx;America/Ciudad_Juarez=mx;America/Coral_Harbour=ca;America/Costa_Rica=cr;America/Coyhaique=cl;America/Creston=ca;America/Cuiaba=br;America/Curacao=cw;America/Danmarkshavn=gl;America/Dawson=ca;America/Dawson_Creek=ca;America/Denver=us;America/Detroit=us;America/Dominica=dm;America/Edmonton=ca;America/Eirunepe=br;America/El_Salvador=sv;America/Fort_Nelson=ca;America/Fortaleza=br;America/Glace_Bay=ca;America/Godthab=gl;America/Goose_Bay=ca;America/Grand_Turk=tc;America/Grenada=gd;America/Guadeloupe=gp;America/Guatemala=gt;America/Guayaquil=ec;America/Guyana=gy;America/Halifax=ca;America/Havana=cu;America/Hermosillo=mx;America/Indiana/Indianapolis=us;America/Indiana/Knox=us;America/Indiana/Marengo=us;America/Indiana/Petersburg=us;America/Indiana/Tell_City=us;America/Indiana/Vevay=us;America/Indiana/Vincennes=us;America/Indiana/Winamac=us;America/Inuvik=ca;America/Iqaluit=ca;America/Jamaica=jm;America/Juneau=us;America/Kentucky/Louisville=us;America/Kentucky/Monticello=us;America/Kralendijk=bq;America/La_Paz=bo;America/Lima=pe;America/Los_Angeles=us;America/Lower_Princes=sx;America/Maceio=br;America/Managua=ni;America/Manaus=br;America/Marigot=mf;America/Martinique=mq;America/Matamoros=mx;America/Mazatlan=mx;America/Menominee=us;America/Merida=mx;America/Metlakatla=us;America/Mexico_City=mx;America/Miquelon=pm;America/Moncton=ca;America/Monterrey=mx;America/Montevideo=uy;America/Montreal=ca;America/Montserrat=ms;America/Nassau=bs;America/New_York=us;America/Nome=us;America/Noronha=br;America/North_Dakota/Beulah=us;America/North_Dakota/Center=us;America/North_Dakota/New_Salem=us;America/Nuuk=gl;America/Ojinaga=mx;America/Panama=pa;America/Paramaribo=sr;America/Phoenix=us;America/Port-au-Prince=ht;America/Port_of_Spain=tt;America/Porto_Velho=br;America/Puerto_Rico=pr;America/Punta_Arenas=cl;America/Rankin_Inlet=ca;America/Recife=br;America/Regina=ca;America/Resolute=ca;America/Rio_Branco=br;America/Santarem=br;America/Santiago=cl;America/Santo_Domingo=do;America/Sao_Paulo=br;America/Scoresbysund=gl;America/Sitka=us;America/St_Barthelemy=bl;America/St_Johns=ca;America/St_Kitts=kn;America/St_Lucia=lc;America/St_Thomas=vi;America/St_Vincent=vc;America/Swift_Current=ca;America/Tegucigalpa=hn;America/Thule=gl;America/Tijuana=mx;America/Toronto=ca;America/Tortola=vg;America/Vancouver=ca;America/Whitehorse=ca;America/Winnipeg=ca;America/Yakutat=us;Antarctica/Casey=aq;Antarctica/Davis=aq;Antarctica/DumontDUrville=aq;Antarctica/Macquarie=au;Antarctica/Mawson=aq;Antarctica/McMurdo=aq;Antarctica/Palmer=aq;Antarctica/Rothera=aq;Antarctica/Syowa=aq;Antarctica/Troll=aq;Antarctica/Vostok=aq;Arctic/Longyearbyen=sj;Asia/Aden=ye;Asia/Almaty=kz;Asia/Amman=jo;Asia/Anadyr=ru;Asia/Aqtau=kz;Asia/Aqtobe=kz;Asia/Ashgabat=tm;Asia/Atyrau=kz;Asia/Baghdad=iq;Asia/Bahrain=bh;Asia/Baku=az;Asia/Bangkok=th;Asia/Barnaul=ru;Asia/Beirut=lb;Asia/Bishkek=kg;Asia/Brunei=bn;Asia/Calcutta=in;Asia/Chita=ru;Asia/Chongqing=cn;Asia/Colombo=lk;Asia/Dacca=bd;Asia/Damascus=sy;Asia/Dhaka=bd;Asia/Dili=tl;Asia/Dubai=ae;Asia/Dushanbe=tj;Asia/Famagusta=cy;Asia/Gaza=ps;Asia/Harbin=cn;Asia/Hebron=ps;Asia/Ho_Chi_Minh=vn;Asia/Hong_Kong=hk;Asia/Hovd=mn;Asia/Irkutsk=ru;Asia/Istanbul=tr;Asia/Jakarta=id;Asia/Jayapura=id;Asia/Jerusalem=il;Asia/Kabul=af;Asia/Kamchatka=ru;Asia/Karachi=pk;Asia/Kathmandu=np;Asia/Katmandu=np;Asia/Khandyga=ru;Asia/Kolkata=in;Asia/Krasnoyarsk=ru;Asia/Kuala_Lumpur=my;Asia/Kuching=my;Asia/Kuwait=kw;Asia/Macao=mo;Asia/Macau=mo;Asia/Magadan=ru;Asia/Makassar=id;Asia/Manila=ph;Asia/Muscat=om;Asia/Nicosia=cy;Asia/Novokuznetsk=ru;Asia/Novosibirsk=ru;Asia/Omsk=ru;Asia/Oral=kz;Asia/Phnom_Penh=kh;Asia/Pontianak=id;Asia/Pyongyang=kp;Asia/Qatar=qa;Asia/Qostanay=kz;Asia/Qyzylorda=kz;Asia/Rangoon=mm;Asia/Riyadh=sa;Asia/Saigon=vn;Asia/Sakhalin=ru;Asia/Samarkand=uz;Asia/Seoul=kr;Asia/Shanghai=cn;Asia/Singapore=sg;Asia/Srednekolymsk=ru;Asia/Taipei=tw;Asia/Tashkent=uz;Asia/Tbilisi=ge;Asia/Tehran=ir;Asia/Tel_Aviv=il;Asia/Thimbu=bt;Asia/Thimphu=bt;Asia/Tokyo=jp;Asia/Tomsk=ru;Asia/Ujung_Pandang=id;Asia/Ulaanbaatar=mn;Asia/Ulan_Bator=mn;Asia/Urumqi=cn;Asia/Ust-Nera=ru;Asia/Vientiane=la;Asia/Vladivostok=ru;Asia/Yakutsk=ru;Asia/Yangon=mm;Asia/Yekaterinburg=ru;Asia/Yerevan=am;Atlantic/Azores=pt;Atlantic/Bermuda=bm;Atlantic/Canary=es;Atlantic/Cape_Verde=cv;Atlantic/Faeroe=fo;Atlantic/Faroe=fo;Atlantic/Madeira=pt;Atlantic/Reykjavik=is;Atlantic/South_Georgia=gs;Atlantic/St_Helena=sh;Atlantic/Stanley=fk;Australia/ACT=au;Australia/Adelaide=au;Australia/Brisbane=au;Australia/Broken_Hill=au;Australia/Darwin=au;Australia/Eucla=au;Australia/Hobart=au;Australia/Lindeman=au;Australia/Lord_Howe=au;Australia/Melbourne=au;Australia/NSW=au;Australia/Perth=au;Australia/Sydney=au;Canada/Eastern=ca;Canada/Pacific=ca;Egypt=eg;Europe/Amsterdam=nl;Europe/Andorra=ad;Europe/Astrakhan=ru;Europe/Athens=gr;Europe/Belfast=gb;Europe/Belgrade=rs;Europe/Berlin=de;Europe/Bratislava=sk;Europe/Brussels=be;Europe/Bucharest=ro;Europe/Budapest=hu;Europe/Busingen=de;Europe/Chisinau=md;Europe/Copenhagen=dk;Europe/Dublin=ie;Europe/Gibraltar=gi;Europe/Guernsey=gg;Europe/Helsinki=fi;Europe/Isle_of_Man=im;Europe/Istanbul=tr;Europe/Jersey=je;Europe/Kaliningrad=ru;Europe/Kiev=ua;Europe/Kirov=ru;Europe/Kyiv=ua;Europe/Lisbon=pt;Europe/Ljubljana=si;Europe/London=gb;Europe/Luxembourg=lu;Europe/Madrid=es;Europe/Malta=mt;Europe/Mariehamn=ax;Europe/Minsk=by;Europe/Monaco=mc;Europe/Moscow=ru;Europe/Nicosia=cy;Europe/Oslo=no;Europe/Paris=fr;Europe/Podgorica=me;Europe/Prague=cz;Europe/Riga=lv;Europe/Rome=it;Europe/Samara=ru;Europe/San_Marino=sm;Europe/Sarajevo=ba;Europe/Saratov=ru;Europe/Simferopol=ua;Europe/Skopje=mk;Europe/Sofia=bg;Europe/Stockholm=se;Europe/Tallinn=ee;Europe/Tirane=al;Europe/Ulyanovsk=ru;Europe/Vaduz=li;Europe/Vatican=va;Europe/Vienna=at;Europe/Vilnius=lt;Europe/Volgograd=ru;Europe/Warsaw=pl;Europe/Zagreb=hr;Europe/Zurich=ch;GB=gb;Hongkong=hk;Indian/Antananarivo=mg;Indian/Chagos=io;Indian/Christmas=cx;Indian/Cocos=cc;Indian/Comoro=km;Indian/Kerguelen=tf;Indian/Mahe=sc;Indian/Maldives=mv;Indian/Mauritius=mu;Indian/Mayotte=yt;Indian/Reunion=re;Iran=ir;Israel=il;Japan=jp;Kwajalein=mh;NZ=nz;PRC=cn;Pacific/Apia=ws;Pacific/Auckland=nz;Pacific/Bougainville=pg;Pacific/Chatham=nz;Pacific/Chuuk=fm;Pacific/Easter=cl;Pacific/Efate=vu;Pacific/Fakaofo=tk;Pacific/Fiji=fj;Pacific/Funafuti=tv;Pacific/Galapagos=ec;Pacific/Gambier=pf;Pacific/Guadalcanal=sb;Pacific/Guam=gu;Pacific/Honolulu=us;Pacific/Kanton=ki;Pacific/Kiritimati=ki;Pacific/Kosrae=fm;Pacific/Kwajalein=mh;Pacific/Majuro=mh;Pacific/Marquesas=pf;Pacific/Midway=um;Pacific/Nauru=nr;Pacific/Niue=nu;Pacific/Norfolk=nf;Pacific/Noumea=nc;Pacific/Pago_Pago=as;Pacific/Palau=pw;Pacific/Pitcairn=pn;Pacific/Pohnpei=fm;Pacific/Ponape=fm;Pacific/Port_Moresby=pg;Pacific/Rarotonga=ck;Pacific/Saipan=mp;Pacific/Tahiti=pf;Pacific/Tarawa=ki;Pacific/Tongatapu=to;Pacific/Truk=fm;Pacific/Wake=um;Pacific/Wallis=wf;Poland=pl;Portugal=pt;ROC=tw;ROK=kr;Singapore=sg;Turkey=tr;US/Central=us;US/Eastern=us;US/Mountain=us;US/Pacific=us';
const TZ_COUNTRY = Object.fromEntries(TZ_TABLE.split(';').map((p) => p.split('=')));
// whole-word match, so a short city like "Male" doesn't match inside "Guatemala"
const hasWord = (text, word) => word.length > 2 && new RegExp(`(^|[^a-z])${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}([^a-z]|$)`).test(text);
const tzCityKey = (s) => String(s || '').split('/').pop().replace(/[_\s]+/g, ' ').trim().toLowerCase();
const countryFromTz = (tz) => {
  if (!tz) return '';
  if (TZ_COUNTRY[tz]) return TZ_COUNTRY[tz];
  const city = tzCityKey(tz);
  let key = Object.keys(TZ_COUNTRY).find((k) => tzCityKey(k) === city);
  if (!key) {
    const text = String(tz).toLowerCase(); // e.g. "(GMT+03:00) Beirut"
    key = Object.keys(TZ_COUNTRY).find((k) => hasWord(text, tzCityKey(k)));
  }
  return key ? TZ_COUNTRY[key] : '';
};
const flagOf = (code, tz) => {
  const c = String(code || '').trim();
  if (c.length === 2 && c.toUpperCase() !== 'UN') return c.toLowerCase();
  return countryFromTz(tz);
};

const API = process.env.REACT_APP_API_BASE_URL;
const JOIN_EARLY_MIN = 5;
const REPORT_WINDOW_MIN = 60; // issues can be reported from the start until 1 hour after (same as before)

// Same issue codes as before
const ISSUES = [
  { id: 1, label: 'Student not joined' },
  { id: 2, label: 'Student left' },
  { id: 3, label: 'Internet issue' },
  { id: 4, label: 'Mic / audio issue' },
  { id: 5, label: 'Zoom link issue' },
];

// The day the teacher sees on their own calendar (local date, YYYY-MM-DD)
const localDay = (offsetDays) => {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const dayToDate = (day) => {
  const v = (day || '').toLowerCase();
  if (v === 'today') return localDay(0);
  if (v === 'tomorrow') return localDay(1);
  if (v === 'yesterday') return localDay(-1);
  return day; // already YYYY-MM-DD
};

const initialsOf = (name = '') =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('') || 'S';

const fmtTime = (d) => d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
const fmtDay = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

// Student's own time + city, e.g. "11:00 PM Los Angeles"
const validTz = (tz) => tz && tz !== 'Unknown' && !tz.startsWith('Etc/GMT');
const studentTime = (date, tz) => {
  if (!validTz(tz)) return '';
  try {
    const t = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true, timeZone: tz });
    const city = tz.split('/').pop().replace(/_/g, ' ');
    return `${t} ${city}`;
  } catch {
    return '';
  }
};

const levelOf = (id) => (id === 2 ? 'Junior' : id === 1 ? 'Little' : 'Group');

const Classes = ({ day, userData }) => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [now, setNow] = useState(() => Date.now());
  const [joiningId, setJoiningId] = useState(null);
  const [reporting, setReporting] = useState({ classId: null, issue: null });
  const [dialog, setDialog] = useState(null); // { tone, title, message }
  const demos = useDemoProjects('teacher'); // to suggest the demo made for the course the parent asked for
  const requestRef = useRef(0);

  const teacherId = userData?.id;

  // ---------- Load the day's classes (same endpoint), refresh every minute ----------
  const fetchClasses = useCallback(async () => {
    if (!teacherId) return;
    const requestId = ++requestRef.current;
    try {
      const res = await axios.get(`${API}/api/teacher/classes/${teacherId}/${dayToDate(day)}`);
      if (requestId !== requestRef.current) return; // a newer request (other day) won
      const list = (res.data?.myClasses || [])
        .map((cls) => {
          const start = new Date(cls.ClassDateTime);
          const taken = Number(cls.sessionsTaken) || 0;
          const total = Number(cls.totalSessions) || 0;
          return {
            id: cls.Id,
            type: cls.Type === 0 ? 'paid' : 'demo',
            IdUser: cls.IdUser,
            image: cls.image || '',
            name: [cls.FirstName, cls.LastName].filter(Boolean).join(' ') || 'Student',
            taken,
            total,
            level: levelOf(cls.IdGradesPlans),
            plan: cls.IdGradesPlans,
            hasPTM: total > 0 && taken === total,
            hasFinish: total > 0 && taken > total,
            countryCode: cls.countryCode || 'UN',
            timezone: cls.timezone || cls.Timezone || '',
            flag: flagOf(cls.countryCode, cls.timezone || cls.Timezone), // demo classes: from the time zone
            start,
            prevProject: cls.lastCourse?.CourseName || '',
            nextProject: cls.nextCourse?.CourseName || '',
            notes: (cls.coursenotes || '').trim(),
            lastCourseLink: cls.lastCourse?.CourseLink,
            lastProjectLink: cls.lastCourse?.CourseProjectLink,
            nextCourseLink: cls.nextCourse?.CourseLink,
            nextProjectLink: cls.nextCourse?.CourseProjectLink,
            issue: cls.Issue ?? null,
            course: cls.InterestedCourse || '', // trial: course the parent asked for ('' = not sure)
            // join times (shown when the server sends them, like the admin page)
            joinKnown: 'TeacherJoin' in cls || 'StudentJoin' in cls,
            teacherJoin: cls.TeacherJoin || null,
            studentJoin: cls.StudentJoin || null,
          };
        })
        .sort((a, b) => a.start - b.start);
      setClasses(list);
      setError('');
    } catch (err) {
      if (requestId === requestRef.current) setError('We couldn’t load your classes.');
    } finally {
      if (requestId === requestRef.current) setLoading(false);
    }
  }, [teacherId, day]);

  useEffect(() => {
    setLoading(true);
    fetchClasses();
    const id = setInterval(() => {
      fetchClasses();
      setNow(Date.now());
    }, 60000);
    return () => clearInterval(id);
  }, [fetchClasses]);

  // Escape closes the dialog
  useEffect(() => {
    if (!dialog) return undefined;
    const onKey = (e) => e.key === 'Escape' && setDialog(null);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [dialog]);

  const stateOf = (cls) => {
    const diffMin = (cls.start - now) / 60000;
    if (diffMin > JOIN_EARLY_MIN) return 'upcoming';
    if (diffMin > -REPORT_WINDOW_MIN) return 'live';
    return 'done';
  };

  // ---------- Join (same server checks, teacher endpoint) ----------
  const handleJoin = async (cls) => {
    const isLive = stateOf(cls) === 'live';
    const zoomTab = isLive ? window.open('', '_blank') : null; // avoids popup blocking on phones/Safari
    setJoiningId(cls.id);
    try {
      const res = await axios.post(`${API}/api/classes/check-availability`, { classId: cls.id });
      const { status, message, zoomUrl } = res.data;

      if (status === 'joining') {
        const join = await axios.post(`${API}/api/classes/confirm-join/teacherjoin`, { classId: cls.id });
        if (join.data.success && zoomUrl) {
          if (zoomTab) zoomTab.location.href = zoomUrl;
          else window.open(zoomUrl, '_blank');
          return;
        }
        zoomTab?.close();
        setDialog({ tone: 'error', title: 'Couldn’t open the class', message: 'Please try again.' });
        return;
      }

      zoomTab?.close();
      if (status === 'early') {
        setDialog({ tone: 'early', title: 'Not time yet', message: `${message || ''} You can join ${JOIN_EARLY_MIN} minutes before the start.` });
      } else if (status === 'expired') {
        setDialog({ tone: 'info', title: 'This class has ended', message });
      } else {
        setDialog({ tone: 'error', title: 'Couldn’t open the class', message: message || 'Please try again.' });
      }
    } catch (err) {
      zoomTab?.close();
      console.error('Join error:', err);
      setDialog({ tone: 'error', title: 'Something went wrong', message: 'Please try again.' });
    } finally {
      setJoiningId(null);
    }
  };

  // ---------- Report an issue (same endpoint and codes) ----------
  const submitIssue = async (classId, issue) => {
    setReporting({ classId, issue });
    try {
      const res = await axios.post(
        `${API}/api/teacher/submitissue`,
        { IdSchedule: classId, IdIssue: issue },
        { headers: { Authorization: `Bearer ${localStorage.getItem('userData')}` } }
      );
      if (res.status === 200) {
        // update right away, then refresh from the server
        setClasses((list) => list.map((c) => (c.id === classId ? { ...c, issue } : c)));
        fetchClasses();
      } else {
        setDialog({ tone: 'error', title: 'Report not sent', message: 'Please try again.' });
      }
    } catch (error) {
      console.error('Error submitting issue:', error);
      setDialog({ tone: 'error', title: 'Report not sent', message: 'Please try again.' });
    } finally {
      setReporting({ classId: null, issue: null });
    }
  };

  // ---------- Render ----------
  if (loading) {
    return (
      <div className="rmcls" aria-busy="true">
        {[0, 1].map((i) => (
          <div key={i} className="rmcls-skel" />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="rmcls">
        <div className="rmcls-empty">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <p>{error}</p>
          <button type="button" className="rmcls-btn" onClick={fetchClasses}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  if (classes.length === 0) {
    return (
      <div className="rmcls">
        <div className="rmcls-empty">
          <FontAwesomeIcon icon={faCalendarDay} />
          <p>No classes {day === 'today' ? 'today' : day === 'tomorrow' ? 'tomorrow' : day === 'yesterday' ? 'yesterday' : 'on this day'}.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="rmcls">
      <ol className="rmcls-list">
        {classes.map((cls) => {
          const state = stateOf(cls);
          const minutesTo = Math.round((cls.start - now) / 60000);
          const canReport = state === 'live' && cls.start.getTime() <= now; // from the start time until 1 hour after
          const theirTime = studentTime(cls.start, cls.timezone);
          // one Join button, shown in the lessons row on desktop and under the time on phones
          const joinBtn = (where) => (
            <button type="button" className={`rmcls-join ${where}`} onClick={() => handleJoin(cls)} disabled={joiningId === cls.id}>
              {joiningId === cls.id ? (
                <span className="rmcls-spinner" aria-label="Opening class" />
              ) : (
                <>
                  <FontAwesomeIcon icon={faVideo} /> Join <FontAwesomeIcon icon={faArrowRight} />
                </>
              )}
            </button>
          );

          return (
            <li key={cls.id} className={`rmcls-card is-${cls.type} is-${state} ${cls.issue != null && cls.issue !== 0 && canReport ? 'has-issue' : ''}`}>
              {/* ---- top: student + time ---- */}
              <div className="rmcls-top">
                <span className="rmcls-avatar-wrap">
                  <span className="rmcls-avatar">
                    {cls.image ? <img src={cls.image} alt="" /> : <span aria-hidden="true">{initialsOf(cls.name)}</span>}
                  </span>
                  {cls.flag && (
                    <span className="rmcls-flag" title={cls.timezone || undefined}>
                      <span className={`fi fi-${cls.flag}`} />
                    </span>
                  )}
                </span>

                <div className="rmcls-who">
                  <h3>
                    {cls.name}
                    {cls.type === 'paid' && cls.IdUser && (
                      <a
                        href={`/StudentProfile/${cls.IdUser}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="rmcls-profile"
                        aria-label={`Open ${cls.name}'s profile in a new tab`}
                      >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                      </a>
                    )}
                  </h3>
                  <div className="rmcls-tags">
                    <span className={`rmcls-tag is-${cls.type}`}>{cls.type === 'paid' ? 'Paid' : 'Trial'}</span>
                    <span className="rmcls-tag">{cls.level}</span>
                    {cls.type === 'paid' && cls.total > 0 && !cls.hasFinish && (
                      <span className={`rmcls-tag ${cls.hasPTM ? 'is-red' : ''}`}>
                        Class {cls.taken}/{cls.total}
                      </span>
                    )}
                    {cls.type === 'paid' && cls.hasPTM && <span className="rmcls-tag is-green">PTM</span>}
                    {cls.type === 'paid' && cls.hasFinish && <span className="rmcls-tag is-blue">Awaiting updates</span>}
                  </div>
                    {cls.joinKnown && (
                      <div className="rmcls-joined">
                        <span className={cls.teacherJoin ? 'is-yes' : ''} title="Teacher join">
                          <FontAwesomeIcon icon={cls.teacherJoin ? faCheck : faXmark} /> TJ{cls.teacherJoin ? ` ${fmtTime(new Date(cls.teacherJoin))}` : ''}
                        </span>
                        <span className={cls.studentJoin ? 'is-yes' : ''} title="Student join">
                          <FontAwesomeIcon icon={cls.studentJoin ? faCheck : faXmark} /> SJ{cls.studentJoin ? ` ${fmtTime(new Date(cls.studentJoin))}` : ''}
                        </span>
                      </div>
                    )}
                </div>

                <div className="rmcls-side">
                  <span className="rmcls-date">{fmtDay(cls.start)}</span>
                  <span className="rmcls-time">{fmtTime(cls.start)}</span>
                  <span className="rmcls-when">
                    {state === 'live' && <b className="rmcls-now">Now</b>}
                    {state === 'upcoming' && minutesTo <= 120 && <>in {minutesTo} min</>}
                    {theirTime && (
                      <span className="rmcls-their">
                        {(state === 'live' || (state === 'upcoming' && minutesTo <= 120)) && ' · '}
                        {theirTime}
                      </span>
                    )}
                  </span>
                  {joinBtn('is-side')}
                </div>
              </div>

              {/* ---- lessons ---- */}
              <div className="rmcls-mid">
                {cls.type === 'paid' ? (
                  <>
                    <div className="rmcls-project">
                      <span className="rmcls-label">Last lesson</span>
                      <strong>{cls.prevProject || '—'}</strong>
                      <div className="rmcls-links">
                        {cls.lastCourseLink && (
                          <a href={cls.lastCourseLink} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faPlayCircle} /> Project
                          </a>
                        )}
                        {cls.lastProjectLink && (
                          <a href={cls.lastProjectLink} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faBook} /> Course
                          </a>
                        )}
                        {cls.notes && (
                          <button type="button" onClick={() => setDialog({ tone: 'info', title: `Notes for ${cls.name}`, message: cls.notes })}>
                            <FontAwesomeIcon icon={faStickyNote} /> Notes
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="rmcls-project is-next">
                      <span className="rmcls-label">This class</span>
                      <strong>{cls.nextProject || '—'}</strong>
                      <div className="rmcls-links">
                        {cls.nextCourseLink && (
                          <a href={cls.nextCourseLink} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faPlayCircle} /> Project
                          </a>
                        )}
                        {cls.nextProjectLink && (
                          <a href={cls.nextProjectLink} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faBook} /> Course
                          </a>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  (() => {
                    const demo = demoForCourse(demos, cls.course, cls.plan);
                    return (
                      <div className="rmcls-project is-next">
                        <span className="rmcls-label">{cls.course ? `Parent asked for ${cls.course}` : 'This class'}</span>
                        <strong>{demo ? `Demo: ${demo.name}` : cls.course ? `Trial class: ${cls.course}` : 'Trial class: demo projects'}</strong>
                        {demo?.link && (
                          <div className="rmcls-links">
                            <a href={demo.link} target="_blank" rel="noopener noreferrer">
                              <FontAwesomeIcon icon={faPlayCircle} /> Demo project
                            </a>
                          </div>
                        )}
                        {!cls.course && <small className="rmcls-course-hint">Course not chosen: recommend one</small>}
                        {cls.course && !demo && <small className="rmcls-course-hint">No demo for this course yet: use a demo project</small>}
                      </div>
                    );
                  })()
                )}
                {joinBtn('is-mid')}
              </div>

              {/* ---- report issue: opens on hover; works only during the class hour ---- */}
              <div className="rmcls-report">
                <div className="rmcls-report-inner">
                  <div className="rmcls-report-head">
                    <span className="rmcls-label">Report issue</span>
                    {!canReport && <small>Available during the class</small>}
                  </div>
                  <div className="rmcls-report-btns" role="group" aria-label="Report an issue">
                    {ISSUES.map((it) => (
                      <button
                        key={it.id}
                        type="button"
                        className={cls.issue === it.id ? 'is-on' : ''}
                        aria-pressed={cls.issue === it.id}
                        disabled={!canReport || reporting.classId === cls.id}
                        onClick={() => submitIssue(cls.id, it.id)}
                      >
                        <FontAwesomeIcon icon={faTriangleExclamation} />{' '}
                        {reporting.classId === cls.id && reporting.issue === it.id ? 'Sending…' : it.label}
                      </button>
                    ))}
                    <button
                      type="button"
                      className={`is-resolve ${cls.issue === 0 ? 'is-on' : ''}`}
                      aria-pressed={cls.issue === 0}
                      disabled={!canReport || reporting.classId === cls.id}
                      onClick={() => submitIssue(cls.id, 0)}
                    >
                      <FontAwesomeIcon icon={faCircleCheck} />{' '}
                      {reporting.classId === cls.id && reporting.issue === 0 ? 'Sending…' : 'Issue resolved'}
                    </button>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ol>

      {/* ---------- Dialog ---------- */}
      {dialog && (
        <div className="rmcls-overlay" onClick={() => setDialog(null)}>
          <div
            className={`rmcls-dialog is-${dialog.tone}`}
            role="dialog"
            aria-modal="true"
            aria-labelledby="rmcls-dialog-title"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="rmcls-dialog-icon">
              <FontAwesomeIcon
                icon={dialog.tone === 'early' ? faHourglassHalf : dialog.tone === 'error' ? faTriangleExclamation : faStickyNote}
              />
            </span>
            <h2 id="rmcls-dialog-title">{dialog.title}</h2>
            {dialog.message && <p className="rmcls-dialog-text">{dialog.message}</p>}
            <div className="rmcls-dialog-actions">
              <button type="button" className="rmcls-btn" onClick={() => setDialog(null)} autoFocus>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Classes;